import 'css-chunksrc/client/pages/documentsPage/reportsPage/reportsList/report/styles.scss';export default {
  "report": "_report_1hy2k_1",
  "header": "_header_1hy2k_7",
  "headerItem": "_headerItem_1hy2k_13",
  "indicators": "_indicators_1hy2k_33",
  "toggle": "_toggle_1hy2k_37",
  "name": "_name_1hy2k_45",
  "icon": "_icon_1hy2k_51",
  "submissionDate": "_submissionDate_1hy2k_59",
  "author": "_author_1hy2k_65",
  "authorAvatar": "_authorAvatar_1hy2k_73",
  "authorName": "_authorName_1hy2k_81",
  "textFields": "_textFields_1hy2k_87",
  "opened": "_opened_1hy2k_94",
  "buttonBox": "_buttonBox_1hy2k_98",
  "button": "_button_1hy2k_98",
  "removeIcon": "_removeIcon_1hy2k_121",
  "contextualMenu": "_contextualMenu_1hy2k_125"
};